module.exports = __webpack_public_path__ + "static/media/right-arrow.f6e37a39.svg";